"use client";

const TESTIMONIALS = [
  {
    name: "Kavitha & Srinivas",
    location: "Hyderabad",
    text: "Our guests were blown away by the digital invitation. The countdown timer and venue maps made everything so easy!",
    initials: "KS",
  },
  {
    name: "Deepika & Ravi",
    location: "Chennai",
    text: "The Telugu Premium template was perfect for our traditional wedding. Every detail was beautiful and cultural.",
    initials: "DR",
  },
  {
    name: "Priyanka & Anil",
    location: "Bangalore",
    text: "We loved how easy it was. Within 3 days we had a stunning invitation ready to share on WhatsApp!",
    initials: "PA",
  },
];

export default function Testimonials() {
  return (
    <section className="iv-test-v2" id="testimonials">
      <div className="iv-test-v2__inner">
        <div className="iv-test-v2__header">
          <h2 className="iv-test-v2__title iv-font-display">
            Loved by Couples <span>Across India</span>
          </h2>
        </div>

        <div className="iv-test-v2__grid">
          {TESTIMONIALS.map((t, i) => (
            <div key={t.name} className={`iv-test-v2__card${i === 0 ? " iv-test-v2__card--featured" : ""}`}>
              <div className="iv-test-v2__stars">
                {[...Array(5)].map((_, i) => (
                  <svg key={i} width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                    <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                  </svg>
                ))}
              </div>
              <blockquote className="iv-test-v2__quote">"{t.text}"</blockquote>
              <div className="iv-test-v2__author">
                <div className="iv-test-v2__avatar">{t.initials}</div>
                <div className="iv-test-v2__info">
                  <div className="iv-test-v2__name">{t.name}</div>
                  <div className="iv-test-v2__location">{t.location}</div>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="iv-test-v2__trust">
          <div className="iv-test-v2__stat">
            <span className="iv-test-v2__stat-number">500+</span>
            <span className="iv-test-v2__stat-label">Happy Couples</span>
          </div>
          <div className="iv-test-v2__stat">
            <span className="iv-test-v2__stat-number">4.9</span>
            <span className="iv-test-v2__stat-label">Average Rating</span>
          </div>
          <div className="iv-test-v2__stat">
            <span className="iv-test-v2__stat-number">100%</span>
            <span className="iv-test-v2__stat-label">Satisfaction</span>
          </div>
        </div>
      </div>
    </section>
  );
}
